import { get, post } from ".";

export const login = async ({
  message,
  signature,
  address,
}: {
  message: string;
  signature: string;
  address: string;
}) => {
  const response = await post<{
    token: string;
  }>("/login/verify", {
    message,
    signature,
    address,
  });
  return response;
};

export const updateAvatar = async (avatar: number) => {
  const response = await post("/login/updateAvatar", {
    avatar,
  });
  return response;
};

export const getUserInfo = async () => {
  const response = await get<{
    address: string;
    didName: string;
    avatar: number;
  }>("/login/userInfo");
  return response;
};
